export default __webpack_public_path__ + "static/media/dj.cc3c9a78.png";